export default {
  init () {
    const self = this;

    $( document.body ).on( 'updated_shipping_method', event => {
      console.log('updated_shipping_method');
      jQuery(document).trigger('wc_update_cart')
      self.updateColspans();
    } )

    $(document).ready(function() {
      self.updateColspans();
    });

    this.initNightexpressInputs();

    $('body').on('change', '#shipping_time_week, #shipping_time_day, #shipping_time_night, #shipping_time_winter', event => {

      // console.trace(event);
      $.ajax({
        type: 'POST',
        url: admin_url.ajax_url,// Replace with your AJAX URL, usually the admin-ajax.php URL
        data: {
          action: 'hr_cart_update_express_status',
          shipping_option: event.target.id
        },
        success: function(response) {
          // Handle the response if needed
          console.log(response);
          $(document).trigger('wc_update_cart');
        }
      });

      if(event.target.id == 'shipping_time_night'){
        this.initNightexpressInputs();
        $('.js-night-express-options').show();
        $('form.woocommerce-cart-form input[name*="shipping_method"]').trigger('change');
        $('body').trigger('updated_shipping_method');
      }else{
        $('.js-night-express-options').hide();

        // let nightexpress = [];
        //
        // $.ajax({
        //   type: 'POST',
        //   url: admin_url.ajax_url,
        //   data: {
        //     action: 'add_night_express',
        //     nightexpress: nightexpress,
        //   },
        //   success: function (data, textStatus, XMLHttpRequest) {
        //     // console.log('le data radio', data);
        //     // if(data != 0){
        //     $('form[name="checkout"] input[name*="shipping_method"]').trigger('change');
        //     // }
        //     // alert(data);
        //     $('body').trigger('updated_shipping_method');
        //   },
        //   error: function (XMLHttpRequest, textStatus, errorThrown) {
        //     alert(errorThrown);
        //   },
        // });
      }

      // trigger change in order to trigger new ajay call
      // $('form[name="checkout"] input[name*="shipping_method"]').trigger('change');
    });
  },
  initNightexpressInputs () {
    console.log('nightexpress init');
    console.log($('.js-night-express-options input[type=checkbox]'));

    $('body').on('change', '.js-night-express-options input[type=checkbox]', event => {
      // $('form[name="checkout"] input[name*="shipping_method"]').trigger('change');
      event.stopImmediatePropagation();

      // console.log('change night express options' , event);

      let $express_options = $('.js-night-express-options input[type=checkbox]:checked');
      let nightexpress = [];

      $express_options.each(function(i, item){
        let obj = {};
        obj[item.name] = item.value;
        nightexpress.push(obj);
      });

      console.log(nightexpress);

      $.ajax({
        type: 'POST',
        url: admin_url.ajax_url,
        data: {
          action: 'add_night_express',
          nightexpress: nightexpress,
        },
        success: function (data, textStatus, XMLHttpRequest) {
          // console.log('le data checkbox', data);
          $('form[name="checkout"] input[name*="shipping_method"]').trigger('change');
          // console.trace(data);

          $('body').trigger( 'wc_update_cart' );
          jQuery(document).trigger('wc_update_cart')
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          alert(errorThrown);
        },

      }).always(function(e) {
        console.log(e);
      });

      // add_night_express
    });
  },
  updateColspans () {
    // Select all table rows with the specified classes
    $('.shop_table .fee td').each(function() {
      $(this).attr('colspan', '2');
    });
    // $('.shop_table .shipping-time-winter td').each(function() {
    //   $(this).attr('colspan', '3');
    // });
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/cart.js